import {
  TypeOfHelpSchema,
  type TypeOfHelpInput,
} from '../TypeOfHelpFormSection/sectionSchema';

/** Transform values to CreateIPReferral API payload */
export default function transformTypeOfHelp(data: TypeOfHelpInput) {
  return TypeOfHelpSchema.transform((input) => {
    if (input.assistanceRequestCode === 'NoHelpNeededFromMicrosoft') {
      return {
        inviteContexts: [],
        consent: {
          consentToShareReferralWithMicrosoftSellers:
            input.consentToShareReferralWithMicrosoftSellers === 'yes',
        },
      };
    }
    return {
      inviteContexts: [
        {
          assistanceRequestCode: input.assistanceRequestCode,
          notes: input.notes,
          /** these values should never change */
          organizationID: 'msft',
          organizationName: 'Microsoft',
        },
      ],
      consent: {
        /** need to default this to true if help is selected */
        consentToShareReferralWithMicrosoftSellers: true,
      },
    };
  }).parse(data);
}
